import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

import PageLayout from "../../components/PageLayout";
import { SectionHeading } from "../../components/SectionHeading";

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 my-6 md:my-10">
      {/* Driver Image */}
      <div className="flex justify-center flex-shrink-0 w-full md:w-1/3">
        <img src="../../../image/driver_image_1.png" alt="Driver Logo" className="w-full max-w-[250px] md:max-w-sm" />
      </div>

      {/* Text Content */}
      <div className="flex flex-col justify-center text-center md:text-left w-full md:w-2/3 space-y-3 md:space-y-4 mt-4 md:mt-0">
        <SectionHeading>{t('CrossBorderHero1')}</SectionHeading>
        <p className="text-sm md:text-base">
          {t('CrossBorderHero2')}
        </p>
      </div>
    </div>
  );
};

// Reusable Step Component
const TutorialStep: React.FC<{ stepNumber: number; title: string; description: string }> = ({ stepNumber, title, description }) => {
  return (
    <div className="flex items-start md:items-center space-x-2 px-2 md:px-4 rounded-md">
      <div className="flex items-center justify-center w-5 h-5 md:w-6 md:h-6 shrink-0 border border-white rounded-full text-xs md:text-sm font-bold mt-0.5 md:mt-0">
        {stepNumber}
      </div>
      <div className="flex-1">
        <span className="font-semibold text-sm md:text-base">{title}: </span>
        <span className="text-sm md:text-base">{description}</span>
      </div>
    </div>
  );
};

// Tutorial Section Component
const TutorialSection: React.FC = () => {
  const { t } = useTranslation();
  const steps = [
    { stepNumber: 1, title: t('CrossBorderApp2Tag1'), description: t('CrossBorderApp2Note1') },
    { stepNumber: 2, title: t('CrossBorderApp2Tag2'), description: t('CrossBorderApp2Note2') },
    { stepNumber: 3, title: t('CrossBorderApp2Tag3'), description: t('CrossBorderApp2Note3') },
    { stepNumber: 4, title: t('CrossBorderApp2Tag4'), description: t('CrossBorderApp2Note4') },
    { stepNumber: 5, title: t('CrossBorderApp2Tag5'), description: t('CrossBorderApp2Note5') },
  ];

  return (
    <div className="flex flex-col md:flex-row flex-wrap items-center gap-6 md:gap-4 my-6 md:my-10">
      <div className="flex flex-col justify-center text-left space-y-3 md:space-y-4 w-full md:max-w-xl order-2 md:order-1">
        <SectionHeading className="text-center md:text-left">{t('CrossBorderApp1')}</SectionHeading>
        <div className="mt-2 md:mt-4"></div>
        {steps.map(({ stepNumber, title, description }) => (
          <TutorialStep key={stepNumber} stepNumber={stepNumber} title={title} description={description} />
        ))}
      </div>
      <div className="flex justify-center flex-shrink-0 w-full md:w-auto order-1 md:order-2">
        <img className="w-[200px] md:w-2/3 max-w-xs" src="/image/example_iPhone.png" alt="Mobile App" />
      </div>
    </div>
  );
};


const InfoSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 my-6 md:my-10">
      {/* Driver Image */}
      <div className="flex justify-center flex-shrink-0 w-full md:w-1/3">
        <img src="../../../image/car.png" alt="Driver Logo" className="w-full max-w-[250px] md:max-w-sm" />
      </div>

      {/* Text Content */}
      <div className="flex flex-col justify-center text-center md:text-left w-full md:w-2/3 space-y-3 md:space-y-4 mt-4 md:mt-0">
        <SectionHeading>{t('CrossBorderLicense1')}</SectionHeading>
        <p className="text-sm md:text-base">
          {t('CrossBorderLicense2')}
        </p>
      </div>
    </div>
  );
}

const CrossBorderPage: React.FC = () => {
  return (
    <PageLayout>
      <div className="flex justify-center items-center w-full px-4 sm:px-0 pt-20">
        <main className="flex flex-col items-center w-full sm:w-[90%] md:w-[85%] lg:w-[80%]">
          <HeroSection />
          <TutorialSection />
          <InfoSection />
        </main>
      </div>
    </PageLayout>
  );
}

export default CrossBorderPage;